import { Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { toSignal } from '@angular/core/rxjs-interop';
import { BreadcrumbService } from '@core/services/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [RouterModule, MatIconModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
})
export class BreadcrumbComponent {
  private readonly breadcrumbService = inject(BreadcrumbService);
  readonly breadcrumbs = toSignal(this.breadcrumbService.breadcrumbs$, { initialValue: [] });
  readonly displayBreadcrumbs = computed(() => {
    const breadcrumbs = this.breadcrumbs();
    return breadcrumbs.length > 0
      ? [{ label: 'Inicio', url: '/' }, ...breadcrumbs]
      : [];
  });
}
